import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { auth } from '../firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import './Navbar.css';

const Navbar = () => {
    const [isShrunk, setIsShrunk] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [progress, setProgress] = useState(0);
    const [user] = useAuthState(auth);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            setIsShrunk(scrollPosition > 50);
            
            // Calculate scroll progress
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const scrollProgress = (scrollPosition / (documentHeight - windowHeight)) * 100;
            setProgress(scrollProgress);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleSignOut = async () => {
        try {
            await auth.signOut();
            setIsMobileMenuOpen(false);
        } catch (error) {
            console.error('Error signing out:', error);
        }
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <>
            <nav className={`navbar ${isShrunk ? 'shrunk' : ''}`}>
                <div className="container">
                    <Link to="/" className="logo" onClick={closeMobileMenu}>
                        Bilik Academy
                    </Link>

                    <button 
                        className="mobile-menu-button"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        aria-label="Toggle menu"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>

                    <div className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
                        <Link to="/" className={location.pathname === '/' ? 'active' : ''} onClick={closeMobileMenu}>
                            Home
                        </Link>
                        <div className="dropdown">
                            <span className="dropdown-trigger">Subjects</span>
                            <div className="dropdown-content">
                                <div className="megamenu">
                                    <div className="megamenu-column">
                                        <h3>Math</h3>
                                        <ul>
                                            <li><Link to="/quiz" state={{ subject: 'math', grade: 9, topic: 'real_numbers' }} onClick={closeMobileMenu}>Real Numbers (9th Grade)</Link></li>
                                            <li><Link to="/quiz" state={{ subject: 'math', grade: 9, topic: 'algebra' }} onClick={closeMobileMenu}>Algebra (9th Grade)</Link></li>
                                            <li><Link to="/quiz" state={{ subject: 'math', grade: 10, topic: 'functions' }} onClick={closeMobileMenu}>Functions (10th Grade)</Link></li>
                                            <li><Link to="/quiz" state={{ subject: 'math', grade: 11, topic: 'calculus' }} onClick={closeMobileMenu}>Calculus (11th Grade)</Link></li>
                                        </ul>
                                    </div>
                                    <div className="megamenu-column">
                                        <h3>Languages</h3>
                                        <ul>
                                            <li><Link to="/quiz" state={{ subject: 'english', grade: 9, topic: 'grammar' }} onClick={closeMobileMenu}>English Grammar (9th Grade)</Link></li>
                                            <li><Link to="/quiz" state={{ subject: 'russian', grade: 9, topic: 'grammar' }} onClick={closeMobileMenu}>Russian Grammar (9th Grade)</Link></li>
                                            <li><Link to="/quiz" state={{ subject: 'russian', grade: 10, topic: 'literature' }} onClick={closeMobileMenu}>Russian Literature (10th Grade)</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {user ? (
                            <>
                                <Link to="/dashboard" className={location.pathname === '/dashboard' ? 'active' : ''} onClick={closeMobileMenu}>
                                    Dashboard
                                </Link>
                                <Link to="/quiz" className={location.pathname === '/quiz' ? 'active' : ''} onClick={closeMobileMenu}>
                                    Start Quiz
                                </Link>
                                <button onClick={handleSignOut} className="btn btn-secondary">
                                    Sign Out
                                </button>
                            </>
                        ) : (
                            <>
                                <Link to="/signin" className={location.pathname === '/signin' ? 'active' : ''} onClick={closeMobileMenu}>
                                    Sign In
                                </Link>
                                <Link to="/signup" style={{ color: 'white' }} className="btn btn-primary" onClick={closeMobileMenu}>
                                    Sign Up
                                </Link>
                            </>
                        )}
                    </div>
                </div>
            </nav>

            {/* Mobile Menu */}
            <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
                <Link to="/" className="mobile-nav-link">Home</Link>
                <div className="mobile-subjects">
                    <div className="mobile-subject-group">
                        <h4>Math</h4>
                        <Link to="/quiz" state={{ subject: 'math', grade: 9, topic: 'real_numbers' }} className="mobile-subject-link">Real Numbers (9th Grade)</Link>
                        <Link to="/quiz" state={{ subject: 'math', grade: 9, topic: 'algebra' }} className="mobile-subject-link">Algebra (9th Grade)</Link>
                        <Link to="/quiz" state={{ subject: 'math', grade: 10, topic: 'functions' }} className="mobile-subject-link">Functions (10th Grade)</Link>
                        <Link to="/quiz" state={{ subject: 'math', grade: 11, topic: 'calculus' }} className="mobile-subject-link">Calculus (11th Grade)</Link>
                    </div>
                    <div className="mobile-subject-group">
                        <h4>Languages</h4>
                        <Link to="/quiz" state={{ subject: 'english', grade: 9, topic: 'grammar' }} className="mobile-subject-link">English Grammar (9th Grade)</Link>
                        <Link to="/quiz" state={{ subject: 'russian', grade: 9, topic: 'grammar' }} className="mobile-subject-link">Russian Grammar (9th Grade)</Link>
                        <Link to="/quiz" state={{ subject: 'russian', grade: 10, topic: 'literature' }} className="mobile-subject-link">Russian Literature (10th Grade)</Link>
                    </div>
                </div>
                <Link to="/dashboard" className="mobile-nav-link">Dashboard</Link>
                {user && <Link to="/quiz" className="mobile-nav-link">Start Quiz</Link>}
                <div className="mobile-auth">
                    {user ? (
                        <button className="btn btn-secondary" onClick={handleSignOut}>Sign Out</button>
                    ) : (
                        <>
                            <Link to="/signin" className="btn btn-secondary">Sign In</Link>
                            <Link to="/signup" className="btn btn-primary">Sign Up</Link>
                        </>
                    )}
                </div>
            </div>

            {/* Progress Bar */}
            <div className="progress-bar" style={{ width: `${progress}%` }} />
        </>
    );
};

export default Navbar; 